import React, { useEffect } from 'react';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import unavailable from '../../../../assests/images/unavailable.png';
import theme from '../../../../assests/theme'
import { WeeklyAvailabilityScheduleUtil } from "../../weeklyAvailability"
import { MuiGrid, MuiTypography, MuiEdit, MuiPaper } from '../../../ui/MaterialUIComponents';
const useStyles = makeStyles((theme) => ({
    popover: {
        pointerEvents: 'none',
    },
    paper: {
        padding: theme.spacing(1)
    },
}));

export default function TeacherUnavailabilityComponent(props) {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [weeklyAvailability, setWeeklyAvailability] = React.useState(JSON.parse(JSON.stringify(props.teacher.weeklyAvailability)));
    const [weeklyAvailabilityDisplayList, setWeeklyAvailabilityDisplayList] = React.useState(null);
    useEffect(() => {
        if (weeklyAvailability.availableForAllHours !== "true" && weeklyAvailability.availableForAllHours !== true) {
            weeklyAvailability.availableForAllHours = "false"
            let weeklyAvailabilitySchedule = WeeklyAvailabilityScheduleUtil.destructorOfWeeklyAvailabilitySchedule(weeklyAvailability)  
            let weeklyAvailabilityDisplay = WeeklyAvailabilityScheduleUtil.constructWeeklyAvailability(weeklyAvailabilitySchedule)
            setWeeklyAvailabilityDisplayList(weeklyAvailabilityDisplay.weeklyAvailabilityDisplayList)
        }
    }, []);
    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    return (
        <div>
            <Typography
                aria-owns={open ? 'mouse-over-popover' : undefined}
                aria-haspopup="true"
                onMouseEnter={handlePopoverOpen}
                onMouseLeave={handlePopoverClose}
            >
                <img src={unavailable} style={{ width: '20px', height: '20px', color: theme.palette.primary.main, marginTop: '5px' }} />
            </Typography>
            <Popover
                id="mouse-over-popover"
                className={classes.popover}
                classes={{
                    paper: classes.paper,
                }}
                open={open}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                
                onClose={handlePopoverClose}
                disableRestoreFocus
            >
                {weeklyAvailabilityDisplayList != undefined && weeklyAvailabilityDisplayList.length > 0
              && weeklyAvailabilityDisplayList.map(weeklyAvailability => (
                <MuiGrid item container justify="flex-start" >
                  <MuiTypography variant="body1" gutterBottom style={theme.gridHeaderTextStyle} align="left" >{weeklyAvailability}</MuiTypography>
                </MuiGrid>
              ))}
            </Popover>
        </div>
    );
}
